
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StockERPDTO } from 'src/app/model/stockERPDTO';




const httpOptions = {
    headers: new HttpHeaders({
      //'Content-Type':  'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Methods': 'GET,POST',
      'Access-Control-Allow-Origin': '*'
    })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class StockERPService {
    private url : string = `${environment.HOST_ERP}`;

  //private url : string = "api_erp";
    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

   

      


 getStockERP(_codigoerp:any):Observable<StockERPDTO[]>{
    return this.http.get<StockERPDTO[]>(`${this.url}/inventario?codigoErp=${_codigoerp}`);
    
 }



}